export default __webpack_public_path__ + "static/media/IconHourglass.38239dda.png";